import type { CurrentClientUserClient } from '@client/entity/current-client-user/domain/model/current-client-user-client.model';
import { MissingCurrentClientUserClientError } from '@client/entity/current-client-user/domain/error/missing-current-client-user-client.error';
import { CurrentUser } from '@shared/entity/current-user/domain/model/current-user.model';

export class CurrentClientUser extends CurrentUser {
  public constructor(
    id: string,
    email: string,
    firstname: string,
    lastname: string,
    public readonly clients: CurrentClientUserClient[] = [],
  ) {
    super(id, email, firstname, lastname);
  }

  public getClientAccessCode(clientId: string): string | null {
    const client = this.clients.find((item) => item.id === clientId);
    if (!client) {
      throw new MissingCurrentClientUserClientError(clientId);
    }

    return client.accessCode ?? null;
  }
}
